import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {ControlloIntegritaModalComponent} from './controllo-integrita-modal';

export const ControlloIntegrotaModule: string = ng
  .module('controllo-integrita-modal', [
    'ui.bootstrap',
    uiRouter
  ])
  .component('controlloIntegritaModalComponent', ControlloIntegritaModalComponent)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/controllo-integrita-modal/controllo-integrita-modal.module.ts